import {
  CalendarIcon,
  CreditCardIcon,
  KebabHorizontalIcon,
  PencilIcon,
  PersonIcon,
  PlusIcon,
  SyncIcon,
  TrashIcon,
  UndoIcon,
} from "@primer/octicons-react";
import { ActionList, ActionMenu, Box, Checkbox } from "@primer/react";

import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { mucPhaiThuApi } from "../../../api/mucPhaiThuApi";
import { AddKhoanNopFromKhoanNop } from "../../../components/add-khoanop-modal/add-from-khoannop";
// import { Button } from '../../../components/buttons';
import { NumberBox } from "devextreme-react/number-box";

import moment from "moment";
import { hoanPhiTongHopApi } from "../../../api/hoanPhiTongHopApi";
import { DefaultConfirm } from "../../../components/confirm";
import {
  HocSinhRender,
  Infomation,
} from "../../../components/hoc-sinh/HocSinhRender";
import { DefaultPopup } from "../../../components/modal";
import { FormGroup } from "../../../components/primer-ui/form-group";
import TextAreaAutoHeight from "../../../components/primer-ui/text-area-auto-height";
import ThuPhiChiTiet from "../../../components/thu-phi/chi-tiet";
import { HuyChungTuModal } from "../../../components/thu-phi/huy-chung-tu";
import Button from "../../../components/ui/button";
import DataTable from "../../../components/ui/data-table";
import { IFocusCell } from "../../../components/ui/data-table/DataTable";
import Text from "../../../components/ui/text";
import TextWithEllipse from "../../../components/ui/text-with-ellipse";
import { showNotify } from "../../../helpers/toast";
import { PageBaseStatus } from "../../../models/pageBaseStatus";
import { sf_mucphaithu_select_byhocsinh_rq } from "../../../models/request/thu-phi/sf_mucphaithu_select_byhocsinh_rq";
import { create_quyet_toan_request } from "../../../models/request/tonghop/create_quyet_toan_request";
import { sf_hachtoan_congno } from "../../../models/response/hach-toan-cong-no/sf_hachtoan_congno";
import {
  HinhThucThanhToanVm,
  sf_mucphaithu,
} from "../../../models/response/thu-phi/sf_mucphaithu";
import { saveHachToanCongNoStart } from "../../../state/actions/hachToanCongNoActions";
import { hocSinhProfileActions } from "../../../state/actions/hocSinhProfileActions";
import { RootState } from "../../../state/reducers";
import { HachToanCongNoDetailModal } from "../../hach-toan-cong-no/detail_modal/index";
import HoanPhiHocSinhPage from "../../hoan-phi-hoc-sinh";

type HocSinhChungTuProps = {
  ts_hocsinh_id?: number;
  dm_truong_id?: number;
  dm_khoi_id?: number;
  dm_he_id?: number;
}

const HocSinhChungTu = (props: HocSinhChungTuProps = {}) => {
  const {
    filter,
    status,
    sf_mucphaithus,
    isShowThuPhiChiTiet,
    isShowThuPhiAddModal,
    sf_mucphaithu_editing,
    ts_hocsinh_viewmodel,
  } = useSelector((x: RootState) => x.hocSinhProfile);
  const [focusedCell, setFocusedCell] = useState<IFocusCell>();
  const navigate = useNavigate();

  const [isShowConfirmModal, setIsShowConfirmModal] = useState(false);
  const [isShowRefundModal, setIsShowRefundModal] = useState(false);
  const [isShowHoanPhiModal, setIsShowHoanPhiModal] = useState(false);
  const [isShowHuyChungTu, setIsShowHuyChungTu] = useState<boolean>(false);
  const [sf_mucphaithu_hoanphi_id, set_sf_mucphaithu_hoanphi_id] = useState(0);

  const [isShowQuyetToanModal, setIsShowQuyetToanModal] = useState(false);
  const [tong_tien_thua, set_tong_tien_thua] = useState<any>(0);
  const [noi_dung_quyet_toan, set_noi_dung_quyet_toan] = useState("");
  const [so_tien_quyet_toan, set_so_tien_quyet_toan] = useState(0);

  const [soChungTu, setSoChungTu] = useState("");
  const [soTienConDu, setSoTienConDu] = useState(Number);
  const [sf_mucphaithu_root_id, setsf_mucphaithu_root_id] = useState(Number);

  const { nam_hoc, ts_hocsinh_id: filter_ts_hocsinh_id } = filter;
  // Ưu tiên dùng ts_hocsinh_id từ props, nếu không có thì dùng từ filter hoặc ts_hocsinh_viewmodel
  const ts_hocsinh_id = props?.ts_hocsinh_id ?? ts_hocsinh_viewmodel?.id ?? filter_ts_hocsinh_id;
  // Ưu tiên dùng từ props, nếu không có thì dùng từ filter hoặc ts_hocsinh_viewmodel
  const dm_he_id = props?.dm_he_id ?? (filter as any).dm_he_id ?? ts_hocsinh_viewmodel?.dm_he_id;
  const dm_khoi_id = props?.dm_khoi_id ?? (filter as any).dm_khoi_id ?? ts_hocsinh_viewmodel?.dm_khoi_id;
  const dm_truong_id = props?.dm_truong_id ?? (filter as any).dm_truong_id ?? ts_hocsinh_viewmodel?.dm_truong_id;

  const dispatch = useDispatch();
  const handleShowAddModal = () => {
    // Đảm bảo có đầy đủ thông tin trước khi hiển thị modal
    if (nam_hoc && ts_hocsinh_id) {
      // Kiểm tra xem đã có đầy đủ thông tin chưa (từ filter hoặc ts_hocsinh_viewmodel)
      const hasFullInfo = 
        dm_he_id !== undefined && dm_he_id !== null &&
        dm_khoi_id !== undefined && dm_khoi_id !== null &&
        dm_truong_id !== undefined && dm_truong_id !== null;
      
      if (!hasFullInfo && !ts_hocsinh_viewmodel) {
        // Nếu chưa có thông tin và chưa load ts_hocsinh_viewmodel, load trước
        const datasend: sf_mucphaithu_select_byhocsinh_rq = { 
          ts_hocsinh_id: ts_hocsinh_id, 
          nam_hoc: nam_hoc 
        };
        dispatch(hocSinhProfileActions.selectHocSinhStart(datasend));
        // Đợi một chút để state được cập nhật trước khi hiển thị modal
        setTimeout(() => {
          dispatch(hocSinhProfileActions.showThuPhiAddModal());
        }, 300);
      } else {
        dispatch(hocSinhProfileActions.showThuPhiAddModal());
      }
    }
  };

  useEffect(() => {
    if (nam_hoc && ts_hocsinh_id) {
      handleReloadChungTu();
    }
    handleReloadTienThuaHocSinh();
  }, [nam_hoc, ts_hocsinh_id]);
  useEffect(() => {
    if (status == PageBaseStatus.is_need_reload) {
      dispatch(hocSinhProfileActions.closeThuPhiAddModal());
      handleReloadChungTu();
      handleSelectLastestChungTu();
      handleReloadTienThuaHocSinh();
    }
  }, [status]);
  const handleReloadChungTu = () => {
    dispatch(
      hocSinhProfileActions.selectChungTuStart({
        nam_hoc,
        ts_hocsinh_id,
      })
    );
  };
  const handleReloadTienThuaHocSinh = async () => {
    const datasend: sf_mucphaithu_select_byhocsinh_rq = {
      ts_hocsinh_id: ts_hocsinh_id,
      nam_hoc: nam_hoc,
    };
    const res = await mucPhaiThuApi.select_tienthua_by_hocsinh(datasend);
    if (res.is_success && res.data && res.data.tong_tien_thua != undefined) {
      set_tong_tien_thua(res.data.tong_tien_thua);
    }
  };
  const handleSelectLastestChungTu = async () => {
    const datasend = {
      nam_hoc: nam_hoc,
      ts_hocsinh_id: ts_hocsinh_viewmodel?.id ?? 0,
    };

    const res = await mucPhaiThuApi.select_by_hocsinh(datasend);
    if (res.is_success) {
      if (res.data !== undefined) {
        dispatch(hocSinhProfileActions.showThuPhiChiTiet(res.data[0]));
      }
    }
  };
  const handleCreateChungTu = (data: any) => {
    dispatch(
      hocSinhProfileActions.createThuPhiFromKhoanNopStart({
        nam_hoc: nam_hoc,
        sf_mucphaithu_id: 0,
        ts_hocsinh_id: ts_hocsinh_viewmodel?.id ?? 0,
        is_tinh_mien_giam: data.is_calculate_miengiam,
        sf_mucthuphis: data.sf_mucthuphis.map((x: any) => {
          return {
            id: x.id,
            sf_mucthuphi_id: x.id,
            so_tien_phai_nop: x.so_tien_phai_nop,
            ghi_chu: x.ghi_chu,
          };
        }),
      })
    );
    handleReloadChungTu();
  };
  type ConfirmShowQuyetToanModalProps = {
    onClose: () => void;
    onConfirmed: () => void;
  };
  const ConfirmShowQuyetToanModal = (props: ConfirmShowQuyetToanModalProps) => {
    return (
      <DefaultConfirm
        onClose={() => {
          props.onClose();
        }}
        onConfirmed={() => {
          props.onConfirmed();
        }}
        text={`Bạn có muốn tạo quyết toán từ khoản còn dư này không?`}
        type="success"
        text_close_button="Đóng"
        text_confirm_button="Xác nhận"
      />
    );
  };
  const handleCloseModal = () => {
    setIsShowQuyetToanModal(false);
  };
  const handleSubmitDetailModal = useCallback((data: sf_hachtoan_congno) => {
    dispatch(saveHachToanCongNoStart(data));
    setIsShowQuyetToanModal(false);
  }, []);

  const handleCreateQuyetToan = async () => {
    if (noi_dung_quyet_toan != "" && so_tien_quyet_toan > 0) {
      const datasend: create_quyet_toan_request = {
        so_tien: so_tien_quyet_toan,
        noi_dung_quyet_toan: noi_dung_quyet_toan,
        nam_hoc: nam_hoc,
      };
      const res = await hoanPhiTongHopApi.create_quyet_toan(datasend);
      if (res.is_success) {
        setIsShowRefundModal(false);
        showNotify({ message: "Tạo quyết toán thành công", type: "success" });
      } else {
        showNotify({
          message: "Tạo quyết toán không thành công",
          type: "warning",
        });
      }
    }
  };
  const calculateCustomSummary = (column: string, data: any[]) => {
    const filteredData = data.filter((item: any) =>
      item.so_chung_tu.includes("CT")
    );
    switch (column) {
      case "tong_tien_dinh_muc":
        return filteredData.reduce(
          (total: number, item: any) => total + (item.tong_tien_dinh_muc || 0),
          0
        );
      case "tong_tien_phai_nop":
        return filteredData.reduce(
          (total: number, item: any) => total + (item.tong_tien_phai_nop || 0),
          0
        );
      default:
        return 0;
    }
  };

  return (
    <Box sx={{ pl: 1 }}>
      <DataTable
        titleComponent={
          <Text
            text="Danh sách chứng từ"
            sx={{ fontSize: 16, fontWeight: 600 }}
          />
        }
        data={sf_mucphaithus}
        height="calc(100vh - 400px)"
        exportEnable
        actionComponent={
          <Box
            sx={{
              display: "flex",
            }}
          >
            <Button
              sx={{ ml: 2 }}
              leadingVisual={PlusIcon}
              variant="primary"
              onClick={handleShowAddModal}
            >
              Thêm chứng từ mới
            </Button>
            <Button
              sx={{ ml: 2 }}
              leadingVisual={SyncIcon}
              variant="default"
              onClick={() => {
                dispatch(
                  hocSinhProfileActions.selectChungTuStart({
                    nam_hoc,
                    ts_hocsinh_id,
                  })
                );
              }}
            >
              Làm mới
            </Button>
          </Box>
        }
        columns={[
          {
            id: "cmd",
            caption: "#",
            width: "60px",
            cellRender: (data: sf_mucphaithu) => {
              return (
                <Box
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                  }}
                >
                  <ActionMenu>
                    <ActionMenu.Button
                      icon={KebabHorizontalIcon}
                      variant="invisible"
                      onClick={(e) => {
                        e.stopPropagation();
                        e.preventDefault();
                      }}
                    >
                      &nbsp;
                    </ActionMenu.Button>
                    <ActionMenu.Overlay>
                      <ActionList>
                        <ActionList.Item
                          onSelect={() => {
                            dispatch(
                              hocSinhProfileActions.showThuPhiChiTiet(data)
                            );
                          }}
                        >
                          <ActionList.LeadingVisual>
                            <PencilIcon />
                          </ActionList.LeadingVisual>
                          <Text text="Sửa chứng từ" />
                        </ActionList.Item>
                        <ActionList.Item
                          onSelect={() => {
                            set_sf_mucphaithu_hoanphi_id(data.id);
                            setIsShowHoanPhiModal(true);
                          }}
                        >
                          <ActionList.LeadingVisual>
                            <UndoIcon />
                          </ActionList.LeadingVisual>
                          <Text text="Tạo hoàn phí" />
                        </ActionList.Item>
                        <ActionList.Item
                          disabled={
                            false ||
                            data.sf_hachtoan_congno_id > 0 ||
                            data.so_chung_tu.includes("NO") ||
                            data.so_chung_tu.includes("RV")
                          }
                          onSelect={() => {
                            set_sf_mucphaithu_hoanphi_id(data.id);
                            setIsShowHuyChungTu(true);
                          }}
                        >
                          <ActionList.LeadingVisual>
                            <TrashIcon />
                          </ActionList.LeadingVisual>
                          <Text text="Hủy chứng từ" />
                        </ActionList.Item>
                      </ActionList>
                    </ActionMenu.Overlay>
                  </ActionMenu>
                </Box>
              );
            },
          },
          {
            caption: "Số chứng từ",
            id: "so_chung_tu",
            dataField: "so_chung_tu",
            width: "100px",
            isMainColumn: true,
            cellRender: (data: any) => (
              <a
                id={`btnChungTu${data.id}`}
                style={{ cursor: "pointer", color: "#3c22ff" }}
                onClick={async () => {
                  dispatch(hocSinhProfileActions.showThuPhiChiTiet(data));
                }}
              >
                {data.so_chung_tu}
              </a>
            ),
          },
          {
            id: "is_da_thanh_toan",
            caption: "Thanh toán",
            width: "100px",
            cellRender: (data: any) => (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Checkbox
                  checked={data.tong_tien_da_nop > 0}
                />
              </div>
            ),
          },
          {
            caption: "Nội dung",
            id: "noi_dung",
            dataField: "noi_dung",
            minWidth: "250px",
            isAllowFocus: false,
            cellRender: (data: any) => (
              <TextWithEllipse text={data.noi_dung || ""} lineNumber={2} />
            ),
          },
          {
            caption: "Tổng tiền",
            id: "tong_tien",
            align: "center",
            isAllowFocus: false,
            columns: [
              {
                caption: "Định mức",
                id: "tong_tien_dinh_muc",
                dataField: "tong_tien_dinh_muc",
                width: "100px",
                isAllowFocus: false,
                cellRender: (data: any) => (
                  <span style={{ display: "block", textAlign: "right" }}>
                    {data.tong_tien_dinh_muc.toLocaleString()}
                  </span>
                ),
              },
              {
                caption: "Miễn giảm",
                id: "tong_tien_mien_giam",
                dataField: "tong_tien_mien_giam",
                width: "100px",
                isAllowFocus: false,
                cellRender: (data: any) => (
                  <span style={{ display: "block", textAlign: "right" }}>
                    {data.tong_tien_mien_giam.toLocaleString()}
                  </span>
                ),
              },
              {
                caption: "Phải nộp",
                id: "tong_tien_phai_nop",
                dataField: "tong_tien_phai_nop",
                width: "80px",
                isAllowFocus: false,
                cellRender: (data: any) => (
                  <span style={{ display: "block", textAlign: "right" }}>
                    {data.tong_tien_phai_nop.toLocaleString()}
                  </span>
                ),
              },
              {
                caption: "Đã nộp",
                id: "tong_tien_da_nop",
                dataField: "tong_tien_da_nop",
                width: "80px",
                isAllowFocus: false,
                cellRender: (data: any) => (
                  <span style={{ display: "block", textAlign: "right" }}>
                    {data.tong_tien_da_nop.toLocaleString()}
                  </span>
                ),
              },
              {
                caption: "Thừa/thiếu",
                id: "tong_tien_thua_thieu",
                dataField: "tong_tien_thua_thieu",
                width: "80px",
                isAllowFocus: false,
                cellRender: (data: any) => (
                  <span style={{ display: "block", textAlign: "right" }}>
                    {data.tong_tien_thua_thieu.toLocaleString()}
                  </span>
                ),
              },
            ],
          },
          {
            caption: "Hình thức thanh toán",
            id: "hinh_thuc_thanh_toan",
            dataField: "hinh_thuc_thanh_toan",
            width: "150px",
            isAllowFocus: false,
            cellRender: (data: any) => {
              const danhSach = data?.HinhThucThanhToanVms as
                | HinhThucThanhToanVm[]
                | undefined;

              if (!danhSach || danhSach.length === 0) {
                return <></>;
              }

              return (
                <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5 }}>
                  {danhSach.map((item, index) => {
                    if (item.hinh_thuc_thanh_toan == null) {
                      return null;
                    }

                    return (
                      <Box
                        key={index}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          gap: 1,
                          fontSize: 0,
                          lineHeight: 1.5,
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            color: "accent.fg",
                            flexShrink: 0,
                          }}
                        >
                          <CreditCardIcon size={14} />
                        </Box>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 0.5,
                            flex: 1,
                            minWidth: 0,
                          }}
                        >
                          <TextWithEllipse
                            text={item.hinh_thuc_thanh_toan}
                            lineNumber={1}
                          />
                          <Box as="span" sx={{ color: "fg.muted" }}>:</Box>
                        </Box>
                        <Box
                          as="strong"
                          sx={{
                            fontWeight: "semibold",
                            color: "fg.default",
                            flexShrink: 0,
                            textAlign: "right",
                          }}
                        >
                          {item.so_tien.toLocaleString()}
                        </Box>
                      </Box>
                    );
                  })}
                </Box>
              );
            },
          },
          {
            caption: "Ngày thu",
            id: "nguoi_thu_username",
            dataField: "nguoi_thu_username",
            width: "150px",
            isAllowFocus: false,
            cellRender: (data: any) => {
              const infos: Infomation[] = [
                {
                  title: "",
                  data: data.nguoi_thu_username,
                  icon: <PersonIcon size={14} />,
                  fontWeight: "500",
                },
                {
                  title: "",
                  data:
                    moment(data.ngay_thu_thuc_te).format("DD/MM/YYYY") ==
                    "01/01/0001"
                      ? ""
                      : moment(data.ngay_thu_thuc_te).format(
                          "DD/MM/YYYY HH:mm"
                        ),
                  icon: <CalendarIcon size={14} />,
                },
              ];
              return <HocSinhRender infors={infos} />;
            },
          },
          {
            caption: "Ghi chú",
            id: "ghi_chu",
            dataField: "ghi_chu",
            // minWidth: "150px",
            isAllowFocus: false,
            cellRender: (data: any) => (
              <TextWithEllipse text={data.ghi_chu || ""} lineNumber={2} />
            ),
          },
        ]}
        // summary={{
        //   calculateCustomSummary: calculateCustomSummary,
        //   items: [
        //     {
        //       name: "totalDinhMuc",
        //       column: "tong_tien_dinh_muc",
        //       summaryType: "custom",
        //       render: (value: number) => `${value.toLocaleString()}`,
        //     },
        //     {
        //       name: "totalMienGiam",
        //       column: "tong_tien_mien_giam",
        //       summaryType: "sum",
        //       render: (value: number) => `${value.toLocaleString()}`,
        //     },
        //     {
        //       name: "totalPhaiNop",
        //       column: "tong_tien_phai_nop",
        //       summaryType: "custom",
        //       render: (value: number) => `${value.toLocaleString()}`,
        //     },
        //     {
        //       name: "totalDaNop",
        //       column: "tong_tien_da_nop",
        //       summaryType: "sum",
        //       render: (value: number) => `${value.toLocaleString()}`,
        //     },
        //     // {
        //     //     name: "totalTraTruoc",
        //     //     column: "tong_tien_tra_truoc",
        //     //     summaryType: "sum",
        //     //     render: (value: number) => `${value.toLocaleString()}`,
        //     // },
        //     // {
        //     //     name: "totalConDu",
        //     //     column: "tong_tien_con_du",
        //     //     summaryType: "sum",
        //     //     render: (value: number) => `${value.toLocaleString()}`,
        //     // },
        //     // {
        //     //     name: "totalConThieu",
        //     //     column: "tong_tien_thua_thieu",
        //     //     summaryType: "sum",
        //     //     render: (value: number) => `${value.toLocaleString()}`,
        //     // },
        //   ],
        // }}
      />
      {isShowThuPhiChiTiet && sf_mucphaithu_editing && (
        <ThuPhiChiTiet
          animationOf={`#btnChungTu${sf_mucphaithu_editing.id}`}
          sf_mucphaithu={sf_mucphaithu_editing}
          onClose={() => {
            dispatch(hocSinhProfileActions.closeThuPhiChiTiet());
            dispatch(
              hocSinhProfileActions.selectChungTuStart({
                nam_hoc,
                ts_hocsinh_id,
              })
            );
          }}
          ts_hocsinh={ts_hocsinh_viewmodel}
          nam_hoc={nam_hoc}
        />
      )}
      {isShowQuyetToanModal && (
        <HachToanCongNoDetailModal
          title={`Quyết toán còn dư của chứng từ ${soChungTu}`}
          onClose={handleCloseModal}
          onSubmit={handleSubmitDetailModal}
          is_saving={status === PageBaseStatus.is_saving}
          nam_hoc={nam_hoc}
          animationOf={"#btnInsert"}
          dm_truong_id={ts_hocsinh_viewmodel?.dm_truong_id}
          ts_hocsinh={ts_hocsinh_viewmodel}
          con_du={soTienConDu}
          sf_mucphaithu_root_id={sf_mucphaithu_root_id}
        />
      )}
      {isShowHoanPhiModal && (
        <HoanPhiHocSinhPage
          onClose={() => {
            setIsShowHoanPhiModal(false);
          }}
          sf_mucphaithu_id={sf_mucphaithu_hoanphi_id}
        />
      )}
      {isShowThuPhiAddModal && ts_hocsinh_id && 
       dm_he_id !== undefined && dm_he_id !== null &&
       dm_khoi_id !== undefined && dm_khoi_id !== null &&
       dm_truong_id !== undefined && dm_truong_id !== null && (
        <AddKhoanNopFromKhoanNop
          filter={{
            nam_hoc: nam_hoc,
            dm_he_id: dm_he_id,
            dm_khoi_id: dm_khoi_id,
            dm_truong_id: dm_truong_id,
          }}
          ts_hocsinh_id={ts_hocsinh_id}
          nam_nhap_hoc={ts_hocsinh_viewmodel?.nam_nhap_hoc}
          isSaving={status === PageBaseStatus.is_saving}
          onCancel={() => {
            window.animationHidePopup("btnAddNew");
            dispatch(hocSinhProfileActions.closeThuPhiAddModal());
          }}
          onSelected={handleCreateChungTu}
        />
      )}
      {isShowConfirmModal && (
        <ConfirmShowQuyetToanModal
          onClose={() => {
            setIsShowConfirmModal(false);
          }}
          onConfirmed={() => {
            setIsShowConfirmModal(false);
            setIsShowQuyetToanModal(true);
            handleReloadChungTu();
          }}
        />
      )}
      {isShowHuyChungTu && (
        <HuyChungTuModal
          onClose={() => {
            setIsShowHuyChungTu(false);
          }}
          sf_mucphaithu_id={sf_mucphaithu_hoanphi_id}
          onChanged={() => {
            setIsShowHuyChungTu(false);
            handleReloadChungTu();
          }}
        />
      )}
      {isShowRefundModal && (
        <DefaultPopup
          title="Tạo quyết toán hoàn trả phụ huynh"
          onClose={() => {
            setIsShowRefundModal(false);
          }}
        >
          <div className="pop-up-form">
            <div className="col-md-12 padding-top-1rem">
              <Box sx={{ width: 500 }}>
                <FormGroup label="Nội dung (*)">
                  <TextAreaAutoHeight
                    block
                    value={noi_dung_quyet_toan}
                    onValueChanged={(value) => {
                      set_noi_dung_quyet_toan(value);
                    }}
                  />
                </FormGroup>
                <FormGroup label="Số tiền">
                  <NumberBox
                    width={"100%"}
                    stylingMode="outlined"
                    value={0}
                    onValueChanged={(value) => {
                      // setHinhThucNopBomIds(id)
                    }}
                  />
                </FormGroup>
              </Box>
            </div>
          </div>
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "7px",
              mt: 5,
            }}
          >
            <Button
              variant="default"
              onClick={() => {
                setIsShowRefundModal(false);
              }}
              leadingVisual={SyncIcon}
              text="Đóng"
            />
            <Button
              variant="primary"
              onClick={handleCreateQuyetToan}
              leadingVisual={PlusIcon}
              text="Tạo quyết toán"
            />
          </Box>
        </DefaultPopup>
      )}
    </Box>
  );
};

export default HocSinhChungTu;
